<script setup lang="ts">
import { useJobEditStore } from '@/stores/useJobEditStore';

const jobEditStore = useJobEditStore();
</script>

<template>
  <div
    :class="$style.jobEditOverlay"
    data-testid="jobEditOverlay"
    @click.prevent="jobEditStore.handleOverlayClick"
  ></div>
</template>

<style lang="scss" module>
@use '@/styles/colors';

.jobEditOverlay {
  position: absolute;
  inset: 0;
  background-color: rgba(colors.$color-text-primary, 0.3);
  pointer-events: all;
  z-index: 10;
}
</style>
